import React from "react";
import { Link } from "react-router-dom";
import { Heart, ArrowRight } from "lucide-react";
import { useWishlist } from "../context/WishlistContext";
import { useCatalog } from "../lib/catalog";
import ProductCard from "../components/ProductCard";

export default function Wishlist() {
  const { ids } = useWishlist();
  const { products } = useCatalog();
  const items = products.filter((p) => ids.includes(p.id));

  if (items.length === 0) {
    return (
      <main className="max-w-[800px] mx-auto px-4 py-20 text-center" data-testid="wishlist-empty">
        <div className="w-20 h-20 rounded-full bg-neutral-100 mx-auto flex items-center justify-center">
          <Heart className="w-8 h-8 text-neutral-400" />
        </div>
        <h1 className="mt-6 font-display text-3xl md:text-4xl font-black">Your wishlist is empty</h1>
        <p className="mt-2 text-neutral-500">Tap the heart on any product to save it here.</p>
        <Link to="/shop" className="mt-8 inline-flex items-center gap-2 h-12 px-7 rounded-full bg-neutral-900 hover:bg-[#FF5A1F] text-white font-semibold text-sm transition">
          Discover Products <ArrowRight className="w-4 h-4" />
        </Link>
      </main>
    );
  }

  return (
    <main className="max-w-[1400px] mx-auto px-4 md:px-8 py-8 md:py-14" data-testid="wishlist-page">
      <h1 className="font-display text-3xl md:text-5xl font-black leading-tight">Wishlist</h1>
      <p className="text-neutral-500 mt-1 text-sm md:text-base">{items.length} item{items.length !== 1 ? "s" : ""} saved</p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-7 mt-6 md:mt-10">
        {items.map((p) => <ProductCard key={p.id} product={p} />)}
      </div>
    </main>
  );
}
